module.exports = __webpack_public_path__ + "static/media/workbg-bigpicture.98165a41.jpg";